import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAriaLive } from '@ally/use-aria-live';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
const ErrorNotificationWrapper = styled.span `
  ${({ theme: { colors, font } }) => `
    line-height: ${font.body.xs.lineHeight};
    color: ${colors.error};
    font-size: ${font.body.xs.size};
    font-weight: bold;
    width: 100%;
    display: inline-block;
  `}
`;
const ErrorNotification = React.forwardRef(({ id, tabIndex, errorMessage, screenReaderErrorId, screenReaderErrorMessage, className, }, ref) => {
    const { announceAssertive } = useAriaLive();
    useEffect(() => {
        if (errorMessage && !screenReaderErrorMessage) {
            announceAssertive(errorMessage);
        }
        // intentionally leaving off the screenReaderErrorMessage prop
        // and announceAssertive function
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMessage]);
    useEffect(() => {
        if (screenReaderErrorMessage) {
            announceAssertive(screenReaderErrorMessage);
        }
        // intentionally leaving off the announceAssertive function
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screenReaderErrorMessage]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ErrorNotificationWrapper, { id: id, ref: ref, tabIndex: tabIndex, className: className }, errorMessage),
        !!screenReaderErrorMessage && (React.createElement(ScreenReaderOnly, { id: screenReaderErrorId, as: "span" }, screenReaderErrorMessage))));
});
/* istanbul ignore next */
const ErrorNotificationForProps = () => React.createElement(React.Fragment, null);
export { ErrorNotification, ErrorNotificationForProps };
//# sourceMappingURL=ErrorNotification.js.map